<script setup lang="ts">
import InquiryHero from "@/pages/Inquiry/InquiryHero.vue";
import InquiryForm from "@/components/InquiryForm/InquiryForm.vue";
import {useInquiryStore} from "@/stores/inquiryStore";
import {nextTick, onMounted} from "vue";
import PhoneItem from "@/components/PhoneItem/PhoneItem.vue";
import {useAboutStore} from "@/stores/aboutStore";

const inquiryStore = useInquiryStore();
const aboutStore = useAboutStore();
const submitData = inquiryStore.formData

onMounted(async () => {
  await nextTick(); // Wait for DOM render
  window.scrollTo({ top: 0, behavior: 'smooth' });
});
</script>

<template>
  <InquiryHero />

  <div class="relative sm:container sm:mx-auto sm:px-4 sm:pt-10 sm:-mt-32">
    <InquiryForm :form-data="inquiryStore.formData" :submit-data="submitData"/>
    <!-- Contact Info -->
    <div class="flex flex-col gap-4 mt-15 text-center text-primary-darkBlue">
      <p class="font-semibold responsive-body-large">CONTACT INFO</p>

      <div class="flex flex-col gap-2">
        <!-- Phone -->
        <div class="flex items-start justify-center gap-2">
          <img src="@/assets/icons/phone.png" alt="Phone" class="h-6 w-6 flex-shrink-0 mt-1"/>
          <div class="flex flex-col gap-2 responsive-body-medium text-primary-darkBlue">
            <div v-for="contact in aboutStore.contactInfo">
              <PhoneItem :contact="contact"/>
            </div>
          </div>
        </div>
        <!-- Address -->
        <div class="flex items-center justify-center lg:justify-start gap-1 responsive-body-medium">
          <img src="@/assets/icons/address.svg" alt="Address" class="h-4 w-3" />
          <span class="whitespace-pre-wrap text-center lg:text-left">
                7 Eleftherias Avenue, Alimos 17455, Athens, Greece
              </span>
        </div>
      </div>
    </div>
  </div>
</template>
